import { computed } from '@vue/composition-api'
import { AggregationResultAttributes } from '@/api/v2/types/aggregation-result'

type ContextKey = 'User' | 'Club' | 'TableDetail'

const AGGREGATION_TYPE_MAP: Record<ContextKey, string[]> = {
  User: [
    'UserAggregation',
    'EodClosingUserAggregation',
    'EodReportUserAggregation',
    'PayrollAggregation',
    'UserReport',
  ],
  Club: [
    'ClubAggregation',
    'EodClosingClubAggregation',
    'EodReportClubAggregation',
    'ClubReport',
  ],
  TableDetail: [
    'TableAggregation',
  ],
}

export type AggregationType = (typeof AGGREGATION_TYPE_MAP)[keyof typeof AGGREGATION_TYPE_MAP][number]
interface Aggregatable { type: AggregationType }

function isAggregationOf(
  aggregation: Aggregatable,
  contextKey: ContextKey,
): boolean {
  return AGGREGATION_TYPE_MAP[contextKey]?.includes(aggregation.type)
}

export function useAggregationType(aggregation?: AggregationResultAttributes) {
  // 未定義時はすべて false
  const isUserAggregation = computed(() => !!aggregation && isAggregationOf(aggregation, 'User'))

  const isClubAggregation = computed(() => !!aggregation && isAggregationOf(aggregation, 'Club'))

  const isTableAggregation = computed(() => !!aggregation && isAggregationOf(aggregation, 'TableDetail'))

  const judgeAggregationType = (
    aggregatable: Aggregatable,
    contextKey: ContextKey,
  ): boolean => !!aggregatable && isAggregationOf(aggregatable, contextKey)

  return {
    judgeAggregationType,
    isUserAggregation,
    isClubAggregation,
    isTableAggregation,
  }
}
